<template>
  <div
    class="absolute flex flex-center flex- bg-white rounded shadow overflow-hidden"
    style="left: 10px; top: 10px; height: 40px"
  >
    <div
      class="w-10 h-full flex flex-no-wrap justify-center rounded-none"
      v-for="(n, i) in route"
    >
      <q-button
        class="p-1 px-1 w-full h-full rounded-none"
        :class="$route.params.view == n ? 'bg-primary' : ''"
        :color="$route.params.view == n ? 'white' : 'primary'"
        :flat="true"
        :square="true"
        :to="{ name: 'monitor', params: { view: n } }"
      >
        <!-- <svg
          v-if="n == 'hybrid'"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 16 16"
        >
          <path
            fill="currentColor"
            d="M6 1H1v14h5zm9 0h-5v5h5zm0 9v5h-5v-5zM0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1zm1 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z"
          />
        </svg> -->
        <svg
          v-if="n == 'hybrid'"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M4 6a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2H4zm16-4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m-5 14H8V9h7zm5 0h-3V9h3zm0-9H8V4h12z"
          />
        </svg>
        <svg
          v-if="n == 'table'"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M9 18h11v-2.675H9zM4 8.675h3V6H4zm0 4.675h3v-2.675H4zM4 18h3v-2.675H4zm5-4.65h11v-2.675H9zm0-4.675h11V6H9zM4 20q-.825 0-1.412-.587T2 18V6q0-.825.588-1.412T4 4h16q.825 0 1.413.588T22 6v12q0 .825-.587 1.413T20 20z"
          />
        </svg>
        <img
          v-if="n == 'map'"
          src="/icons/map-01.png"
          alt=""
          width="17"
          style="object-fit: contain"
          :style="
            $route.params.view == n
              ? { filter: ' invert(1) ' }
              : {
                  filter:
                    'invert(40%) sepia(85%) saturate(674%) hue-rotate(172deg) brightness(87%) contrast(101%)',
                }
          "
        />
        <svg
          v-if="n == 'multi'"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 10.5V4h6v6.5zm10 0V4h6v6.5zm-10 10V14h6v6.5zm10 0V14h6v6.5z"
          />
        </svg>
      </q-button>
      <div
        style="
          background: rgb(218, 220, 224);
          width: 1px;
          height: calc(80 / 40px * 100);
        "
      />
      <q-tooltip
        content-class="bg-primary"
        content-style="text-transform: capitalize;z-index:99999;"
      >
        {{ `${n} View` }}
      </q-tooltip>
    </div>
    <div
      class="w-10 h-full flex flex-no-wrap justify-center rounded-none relative"
    >
      <q-button
        class="p-1 px-1 w-full h-full rounded-none"
        color="grey-8"
        :flat="true"
        :square="true"
        icon="settings"
      />
      <q-menu>
        <div class="p-4 flex flex-col gap-2">
          Live tracking default view
          <q-select
            class="w-full"
            v-model="defaultView"
            :options="route"
            outlined
            dense
          />
        </div>
      </q-menu>

      <q-tooltip content-class="bg-primary">
        Set your default view for live tracking
      </q-tooltip>
    </div>
  </div>
</template>

<script setup>
import QButton from '../playback/QButton.vue';
import { useMonitorStore } from '../monitor-view/monitor';

const { defaultView } = useMonitorStore();

const route = ['hybrid', 'map', 'table', 'multi'];
</script>

<style scoped></style>
